/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CanceledOrderAdminDto } from '../models/CanceledOrderAdminDto';
import type { GetCanceledOrderByOrderAdminResponse } from '../models/GetCanceledOrderByOrderAdminResponse';
import type { Pagination1OfCanceledOrderAdminListedDto } from '../models/Pagination1OfCanceledOrderAdminListedDto';
import type { RoleType } from '../models/RoleType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CanceledOrdersService {
    /**
     * **Required Policy:** `ViewCanceledOrders`
     * @returns CanceledOrderAdminDto OK
     * @throws ApiError
     */
    public static getCanceledOrderByIdAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<CanceledOrderAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/canceledorders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCanceledOrders`
     * @returns GetCanceledOrderByOrderAdminResponse OK
     * @throws ApiError
     */
    public static getCanceledOrderByOrderAdmin({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetCanceledOrderByOrderAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/canceledorders/order/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCanceledOrders`
     * @returns Pagination1OfCanceledOrderAdminListedDto OK
     * @throws ApiError
     */
    public static getCanceledOrdersAdmin({
        fromDate,
        toDate,
        cancelerRole,
        orderBranchId,
        orderServiceId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        fromDate?: string,
        toDate?: string,
        cancelerRole?: RoleType,
        orderBranchId?: number,
        orderServiceId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfCanceledOrderAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/canceledorders',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'cancelerRole': cancelerRole,
                'orderBranchId': orderBranchId,
                'orderServiceId': orderServiceId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
